/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(applicationId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetConsumerDiscountRenewalApplication: {
        $xmlns: 'http://dobs.pa.gov/nd/application/bpm/1.0',
        ApplicationID: applicationId
      }
    },
    blueprintArrays: [
      'GetConsumerDiscountRenewalApplicationResponse.BranchLicenses.ND_AppLicenseConsumerDiscountRenewBranch',
      'GetConsumerDiscountRenewalApplicationResponse.ApplicationDocuments.ND_ApplicationDocument'
    ],
    blueprint: {
      id: '$..ND_AppLicenseConsumerDiscountRenew.ID',
      applicationId: '$..ND_AppLicenseConsumerDiscountRenew.ApplicationID',
      hasUpdatedLicenseContacts: '$..HasUpdatedLicenseContacts',
      hasCriminalOfficer: '$..HasCriminalOfficer',
      hasCriminalOfficerExplaination: '$..HasCriminalOfficerExplaination',
      hasCriminalOfficerDocument: {
        fileId: '$..HasCriminalOfficerDocumentID',
        fileName: '$..HasCriminalOfficerDocumentName'
      },
      hasOfficerWithAdministrativeAction: '$..HasOfficerWithAdministrativeAction',
      hasOfficerWithAdministrativeActionExplaination: '$..HasOfficerWithAdministrativeActionExplaination',
      hasOfficerWithAdministrativeActionDocument: {
        fileId: '$..HasOfficerWithAdministrativeActionDocumentID',
        fileName: '$..HasOfficerWithAdministrativeActionDocumentName'
      },
      hasLegalProceedings: '$..HasLegalProceedings',
      hasLegalProceedingsExplaination: '$..HasLegalProceedingsExplaination',
      hasLegalProceedingsDocument: {
        fileId: '$..HasLegalProceedingsDocumentID',
        fileName: '$..HasLegalProceedingsDocumentName'
      },
      bondCompanyId: '$..BondCompanyID',
      bondNumber: '$..BondNumber',
      bondDocument: {
        fileId: '$..BondDocumentID',
        fileName: '$..BondDocumentName'
      },
      commonStockAmount: '$..CommonStockAmount',
      preferredStockAmount: '$..PreferredStockAmount',
      paidInSurplusAmount: '$..PaidInSurplusAmount',
      retainedEarningsAmount: '$..RetainedEarningsAmount',
      otherAmount: '$..OtherAmount',
      totalStockholdersAmount: '$..TotalStockholdersAmount',
      otherAmountDescription: '$..OtherAmountDescription',
      certificationName: '$..CertificationName',
      isCertified: '$..IsCertified',
      branchLicenses: [
        '$..ND_AppLicenseConsumerDiscountRenewBranch',
        {
          id: '$.ID',
          applicationId: '$.ApplicationID',
          branchLicenseId: '$.BranchLicenseID',
          isRenewing: '$.IsRenewing',
          bondCompanyId: '$.BondCompanyID',
          bondNumber: '$.BondNumber',
          isRenewed: '$.IsRenewed', //checks if ND_LicenseRenewal record exists for the Branch License
          paidDate: '$.PaidDate',
          bondExpirationDate: '$.BondExpirationDate'
        }
      ],
      applicationDocuments: [
        '$..ND_ApplicationDocument',
        {
          fileId: '$.DocumentID',
          fileName: '$..Name'
        }
      ],
      isResubmission: '$..IsResubmission'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.isCertified = response.isCertified === '1';
      if (response.bondExpirationDate) {
        response.bondExpirationDate = moment(response.bondExpirationDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
      }
      _.each(response.branchLicenses, function(branchLicense) {
        branchLicense.isRenewing = branchLicense.isRenewing === '1';
        branchLicense.isRenewed = branchLicense.isRenewed === '1';
        if (branchLicense.bondExpirationDate) {
          branchLicense.bondExpirationDate = moment(branchLicense.bondExpirationDate, 'YYYY-MM-DD');
        }
      });
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });
  return defer.promise();
};
